/**
 * Etapa em que o funil comercial termina (lead não convertido na régua).
 * Manter alinhado com backend/src/utils/vendasFunnel.js.
 */
export const FUNIL_ETAPA_ENCERRADA = 5;

const LEGACY_ETAPA_PARA_ATUAL = {
  6: 4,
  7: 5,
  8: 5,
};

export function normalizarEtapaVendasLegada(etapa) {
  if (etapa == null || etapa === "") return etapa;
  const n = Number(etapa);
  if (Number.isNaN(n)) return etapa;
  const mapped = LEGACY_ETAPA_PARA_ATUAL[n];
  return mapped !== undefined ? mapped : n;
}
